import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

export const sectionStyles: SxProps<Theme> = {
    mt: 3,
};

export const cardStyles: SxProps<Theme> = {
    p: 3,
    mb: 3,
};

export const headerStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: { xs: 'flex-start', sm: 'center' },
    justifyContent: 'space-between',
    gap: 2,
    mb: 1,
};

export const cardTitleStyles: SxProps<Theme> = {
    fontWeight: 600,
};

export const cardHintStyles: SxProps<Theme> = {
    color: 'text.secondary',
    mb: 2.5,
};

export const emptyStyles: SxProps<Theme> = {
    color: 'text.secondary',
};
